import { size } from '@op/util'
import type { PayloadAction } from '@reduxjs/toolkit'

export const toIntAction = <T extends PayloadAction<any>>(a: T) => ({
	...a,
	payload: size(a.payload),
})
